module.exports = __webpack_public_path__ + "static/media/ribbon.7705bda4.svg";